import React, { useState } from "react";
import { useMutation } from "react-query";
import { find } from "lodash";

import { fetchApi } from "helpers/reactQueryApi";
import DropDown from "components/shared/DropDown";
import classNames from "classnames";

export default function ToggleStreamSubscribeItem({
  streamSlug,
}: {
  streamSlug: string;
}) {
  const currentStream = find(Preload.current_network.activitystreams, {
    slug: streamSlug,
  });
  const [subscribed, setSubscribed] = useState(
    !!currentStream?.subscription_status,
  );

  const { mutate: toggleSubscribe, isLoading } = useMutation(
    () =>
      fetchApi(`/activitystreams/${streamSlug}/subscribe`, {
        method: subscribed ? "DELETE" : "POST",
      }),
    {
      onSuccess: ({ subscription_status }: { subscription_status: boolean }) =>
        setSubscribed(subscription_status),
    },
  );

  return (
    <DropDown.Item
      text={
        subscribed
          ? I18n.t("js.activitystreams.stream.unsubscribe")
          : I18n.t("js.activitystreams.stream.subscribe")
      }
      onSelect={() => toggleSubscribe()}
      linkStyle={classNames({ "text-muted cursor-wait": isLoading })}
    />
  );
}
